export default {"src":"/_next/static/media/ar.fa96df67.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};